/**
 * Converts legacy format into new format.
 * @param properties
 */
const restructureLegacyProperties = (properties) => {
  const { label, eventLabel, category, value, eventValue, ...strippedProps } =
    properties;

  return {
    label: label || eventLabel,
    category,
    value: value || eventValue,
    properties: strippedProps,
  };
};

export default restructureLegacyProperties;
